<script lang="ts" setup>
import { useUserPrintingAppStore } from '~/store/UserPrintingAppStore'

defineProps<{
  tournament: ManageTournament
}>()

const printStore = useUserPrintingAppStore()

const connected = ref(false)

setInterval(() => {
  if (printStore.ePosDevice) {
    // @ts-expect-error - no types
    connected.value = printStore.ePosDevice.isConnected() === 1
  }
  else {
    connected.value = false
  }
}, 5000)

onMounted(() => {
  if (printStore.ePosDevice) {
    // @ts-expect-error - no types
    connected.value = printStore.ePosDevice.isConnected() === 1
  }
})
</script>

<template>
  <div
    v-if="'autoplay' in tournament"
    class="mr-1 flex gap-1 items-center"
  >
    <UiBadge
      v-if="printStore.isUsingNetworkPrinter"
      :variant="connected ? 'success' : 'warning'"
    >
      <template v-if="connected">
        {{ $t('Printer connected') }}
      </template>
      <template v-else>
        {{ $t('Printer disconnected') }}
      </template>
    </UiBadge>
    <UiBadge
      v-if="tournament.autoplay"
      variant="info"
    >
      {{ $t('Autoplay is enabled') }}
    </UiBadge>
    <UiBadge
      v-if="!tournament.autoplay"
      variant="warning"
    >
      {{ $t('Autoplay is disabled') }}
    </UiBadge>
  </div>
</template>

<style>

</style>
